import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Card, CardHeader, CardContent, Grid, IconButton, } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { AddImage, } from './components'
import { DELETE, NEUTRAL } from 'constants/filesStatus'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
  },
  imageGrid: {
    position: 'relative',
    border: `1px dashed ${theme.palette.divider}`,
    padding: theme.spacing(6),
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  image: {
    width: '100%',
  },
  action: {
    position: 'absolute',
    top: 0,
    right: 0,
  }
}));

const UploadImages = props => {
  const { className, files, name, isMulti, handleImagesChange, ...rest } = props;

  const classes = useStyles();

  const deleteImage = (index) => {
    if (typeof files[index].name === 'string') {
      handleImagesChange(files.filter((elem, fileIndex) => (fileIndex !== index)))
    } else {
      handleImagesChange(files.map((elem, fileIndex) => {
        if (fileIndex === index) {
          return { ...elem, status: DELETE }
        }
        return elem
      }))
    }
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title={name} />
      <CardContent>
        <Grid container spacing={3}>
          {files.map((image, index) => {
            const isNew = typeof image.name == 'string'
            return  isNew || (!isNew && image.status === NEUTRAL) ? (
                <Grid key={index} item md={4} sm={12}>
                  <div className={classes.imageGrid}>
                    {typeof image.name == 'string' ? image.name : (
                      <img
                        alt="Uploaded"
                        className={classes.image}
                        src={image.url}
                      />
                    )}
                    <IconButton
                      className={classes.action}
                      color="inherit"
                      key="close"
                      onClick={() => { deleteImage(index) }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                </Grid>
              ) : null
            })}
          <AddImage files={files} handleImagesChange={handleImagesChange} isMulti={isMulti}/>
        </Grid>
      </CardContent>
    </Card>
  );
};

UploadImages.propTypes = {
  name: PropTypes.string,
  isMulti: PropTypes.bool,
  files: PropTypes.arrayOf(PropTypes.object),
  handleImagesChange: PropTypes.func,
  className: PropTypes.string
};

export default UploadImages;
